var _rect, _rect2, _rect3, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": 3,
    role: "img",
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cvv3Title_noFocus"
  }, "3 d\xEDgitos del dorso") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cvv3Title_noFocus"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 36,
    height: 24,
    rx: 4,
    stroke: "#A3A7B7",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 24,
    height: 5,
    rx: 1,
    fill: "#A3A7B7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 36,
    height: 5,
    fill: "#A3A7B7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 8,
    r: 8,
    fill: "#6B6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8464 7.92383L25.9201 9.0415L26.4875 9.43457L27.2087 8.21094L27.9333 9.47217L28.4973 9.05859L27.5983 7.95117L28.9348 7.63672L28.7263 6.9668L27.4685 7.50342L27.5881 6.02344H26.8977L27.0036 7.48291L25.7355 6.93603L25.5305 7.5957L26.8464 7.92383ZM30.7505 7.92383L29.8242 9.0415L30.3916 9.43457L31.1128 8.21094L31.8374 9.47217L32.4014 9.05859L31.5024 7.95117L32.8389 7.63672L32.6304 6.9668L31.3726 7.50342L31.4922 6.02344H30.8018L30.9077 7.48291L29.6396 6.93603L29.4346 7.5957L30.7505 7.92383ZM34.6546 7.92383L33.7283 9.0415L34.2957 9.43457L35.0169 8.21094L35.7415 9.47217L36.3055 9.05859L35.4065 7.95117L36.743 7.63672L36.5345 6.9668L35.2767 7.50342L35.3963 6.02344H34.7059L34.8118 7.48291L33.5438 6.93603L33.3387 7.5957L34.6546 7.92383Z",
    fill: "#F8F8F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/cvv.0c30705dde94c4c0dff6f07103d67766.svg";
export { ForwardRef as ReactComponent };